import firebase from 'firebase';




const firebaseConfig = {
    apiKey: "AIzaSyDNG-9GxwszE3vl420jA12pudDcE3W6HVA",
    authDomain: "fb-clone-a457e.firebaseapp.com",
    databaseURL: "https://fb-clone-a457e.firebaseio.com",
    projectId: "fb-clone-a457e",
    storageBucket: "fb-clone-a457e.appspot.com",
    messagingSenderId: "712285402661",
    appId: "1:712285402661:web:f8ab838811fc075640b1cc",
    measurementId: "G-649PGDH59N"
  };

  const firebaseApp = firebase.initializeApp(firebaseConfig);
  const db = firebaseApp.firestore();
  const auth = firebase.auth();
  const provider = new firebase.auth.GoogleAuthProvider();
  const storage = firebase.storage;

  export { auth, provider };
  export default db;